import { Routes } from '@angular/router';
import { ErrorPage } from './routes/error-page/error-page';

export const routes: Routes = [
  {
    path: ':venueID/order-success',
    loadComponent: () =>
      import('./routes/order-success/order-success').then((m) => m.OrderSuccessPage),
  },
  {
    path: 'order-success',
    loadComponent: () =>
      import('./routes/order-success/order-success').then((m) => m.OrderSuccessPage),
  },
  {
    path: ':venueID',
    loadComponent: () => import('./routes/menu-list/menu-list').then((m) => m.MenuList),
  },
  {
    path: ':venueID/:menuID',
    loadComponent: () => import('./routes/category-list/category-list').then((m) => m.CategoryList),
  },
  {
    path: ':venueID/:menuID/:categoryID',
    loadComponent: () => import('./routes/product-list/product-list').then((m) => m.ProductList),
  },
  {
    path: ':venueID/:menuID/:categoryID/:productID',
    loadComponent: () =>
      import('./routes/product-detail/product-detail').then((m) => m.ProductDetail),
  },
  { path: '', component: ErrorPage },
  { path: '**', redirectTo: '' },
];
